module.exports = __webpack_public_path__ + "img/5.038b9292.jpg";